export class NimbusGridGroup<T = any> {
  public get visible(): boolean {
    return !this.parent || (this.parent.visible && !this.parent.closed);
  }

  public constructor(
    public readonly name: string,
    public groupByFn: (item: T) => boolean,
    public closed = false,
    public level = 0,
    public closeble = true,
    public readonly id?: string,
    public readonly parent?: NimbusGridGroup,
  ) {}
}
